import axios from 'axios';

const getConfiguracoesMoedas = params => axios.get('/configuracoes-moedas', {
  params,
});

const createConfiguracaoMoeda = data => axios.post('/configuracoes-moedas', data);

const deleteConfiguracaoMoeda = id => axios.delete(`/configuracoes-moedas/${id}`);


export default {
  getConfiguracoesMoedas,
  createConfiguracaoMoeda,
  deleteConfiguracaoMoeda,
};
